const ExternalFaqs = [
  {
    question: 'faq.external.question1',
    answer: [
      [
        'faq.external.q1.answer1',
        'faq.external.q1.answer2',
        'faq.external.q1.answer3',
      ],
    ],
  },
  {
    question: 'faq.external.question2',
    answer: ['faq.external.q2.answer1'],
  },
  {
    question: 'faq.external.question3',
    answer: ['faq.external.q3.answer1'],
  },
  {
    question: 'faq.external.question4',
    answer: ['faq.external.q4.answer1'],
  },
  {
    question: 'faq.external.question5',
    answer: ['faq.external.q5.answer1'],
  },
]

export { ExternalFaqs }
